export default __webpack_public_path__ + "static/flag-mexico-604a377ab4420592cec948dde4a51f4c.svg";